
    import {Inject, Options, Vue} from 'vue-property-decorator';
    import {Getter} from 'vuex-class';
    import getters from '@/profile-creation-wizard/store/creation/getters';
    import HeadlineSelection from '@/profile-creation-wizard/components/for-creation/ui/1_headline/HeadlineSelection.vue';
    import HeadlineSide from '@/profile-creation-wizard/components/for-creation/ui/1_headline/HeadlineSide.vue';
    import RepatriationOnboardingModal from '@/profile-creation-wizard/components/for-creation/ui/1_headline/RepatriationOnboardingModal.vue';
    import {DI} from '@/profile-creation-wizard/common/DependencyInjection';
    import {CreationFormValidation} from '@/profile-creation-wizard/components/for-creation/ProfileCreationForm';
    import {TrackingRepository} from '@/common/repositories/track/TrackingRepository';
    import Step from '@/profile-creation-wizard/common/ui/step/Step.vue';
    import {ProfileCreationForm} from '@/profile-creation-wizard/types';
    import {RouteRecordNameGeneric} from 'vue-router';

    @Options({
        components: {
            Step,
            HeadlineSide,
            HeadlineSelection,
            RepatriationOnboardingModal,
        },
    })
    export default class HeadlineStep extends Vue {
        @Inject({from: DI.creationFormValidation})
        creationFormValidation!: CreationFormValidation;
        @Inject({from: DI.trackingRepository})
        trackingRepository!: TrackingRepository;
        @Getter(getters.creationForm)
        creationForm!: ProfileCreationForm;
        progressPercentage = 0;

        get hasValidFieldPart(): boolean {
            return this.creationFormValidation.isHeadlineValid(this.creationForm.headline);
        }

        get repatriatedCompany(): string {
            return this.$route.query.repatriationCompanyName?.toString() ?? '';
        }

        get isRepatriationObFfEnabled(): boolean {
            return this.$features.repatriationOpportunityFreelancerOnboarding;
        }

        goNext(): void {
            this.trackingRepository.track('headline-input-freelancer', {
                headline: this.creationForm.headline,
            });

            this.$router.push({name: this.$router.currentRoute.value.meta.nextStep as RouteRecordNameGeneric});
        }

        headlineKeypressEnter(): void {
            if (this.hasValidFieldPart) {
                this.goNext();
            }
        }
    }
